// extracted by mini-css-extract-plugin
export default {"ProductCard":"ProductCard_ProductCard__iCrTU"};